import processSubstrateSuggestionsResponse from 'owa-recipient-common/lib/actions/processSubstrateSuggestionsResponse';
import removeDuplicateResultsFromResponse from '../../utils/removeDuplicateResultsFromResponse';
import processFindPeopleResult from 'owa-recipient-common/lib/actions/processFindPeopleResult';
import FindRecipientPersonaType from 'owa-recipient-common/lib/store/schema/FindRecipientPersonaType';
import { SubstrateSearchSuggestionsResponse } from 'owa-search-service';
import FindPeopleResponseMessage from 'owa-service/lib/contract/FindPeopleResponseMessage';
import shouldUse3SPeopleSuggestions from 'owa-substrate-people-suggestions/lib/utils/shouldUse3SPeopleSuggestions';
import { action } from 'satcheljs/lib/legacy';

export default action('processResponseResults')(function processResponseResults(
    resultList: FindRecipientPersonaType[],
    response: any,
    appendResults: boolean,
    maxResults?: number,
    returnMaskedRecipients?: boolean
) {
    if (appendResults) {
        const currentResultsMap = new Map<string, FindRecipientPersonaType>();
        resultList.forEach(value => {
            currentResultsMap[value.EmailAddress.EmailAddress] = value;
        });
        removeDuplicateResultsFromResponse(currentResultsMap, response);
    }

    if (shouldUse3SPeopleSuggestions()) {
        processSubstrateSuggestionsResponse(
            resultList,
            response as SubstrateSearchSuggestionsResponse,
            appendResults,
            maxResults,
            returnMaskedRecipients
        );
    } else {
        processFindPeopleResult(
            resultList,
            response as FindPeopleResponseMessage,
            appendResults,
            maxResults
        );
    }
});
